import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

export const authenticationGuard: CanActivateFn = (_route, state) => {
  const authentication = inject(AuthenticationService);
  const router = inject(Router);

  if (authentication.isLoggedIn()) {
    return true;
  }

  // A protected route entered directly (address bar, refresh, or bookmark) should
  // return the visitor to the public home page. UI controls that intentionally
  // start a protected action provide this state so the user can authenticate and
  // return to the resource afterwards.
  const navigationState = router.currentNavigation()?.extras.state;
  if (navigationState?.['redirectUnauthenticatedToLogin'] === true) {
    return router.createUrlTree(['/auth/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  return router.parseUrl('/home');
};
